import { defineRouting } from "next-intl/routing";

import { COOKIE_NAME, defaultLocale, locales } from "./config";

export const routing = defineRouting({
  locales,
  defaultLocale,

  // No prefix for the default locale
  localePrefix: "always",

  // Will be merged with the defaults
  localeCookie: {
    // Custom cookie name
    name: COOKIE_NAME,
    // Expire in one year 60 * 60 * 24 * 365 = 31536000 seconds
    maxAge: 31536000,
  },
});
